import React from 'react';
import styled from 'styled-components/macro';
import PhoneInput from 'react-phone-number-input';
import { Typography } from '@deeptrue-frontend/ui';
import 'react-phone-number-input/style.css';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StyledPhone = styled(({ hasError, ...rest }) => <PhoneInput {...rest} />)`
  & .react-phone-number-input__row {
    padding: 0 19px;
    outline: none;
    height: 50px;
    width: 100%;
    border: 1px solid #b5b5b0;

    &:hover {
      box-shadow: ${({ theme }) => theme.shadows.input};
    }

    &:focus-within {
      padding: 0 18px;
      background-color: white;
      border-color: ${({ theme }) => theme.colors.azureRadiance};
      border-width: 2px;
    }

    input {
      border: 0;

      &::placeholder {
        color: ${({ theme }) => theme.colors.driarGray};
      }
    }

    ${({ theme, hasError }) =>
      hasError &&
      `
      border-color: ${theme.colors.punch};
      border-width: 2px;
      &:active,
      &:focus {
        border-color: ${theme.colors.punch};
      }
  `}
  }
`;

interface SelectOptionsType {
  value: string | number;
  label: string;
}

interface PhoneProps {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  hasError?: any;
  width?: string;
  onChange: any;
  name: string;
  value?: string | null;
}

const Phone = ({
  label,
  hasError = false,
  helperText,
  onChange,
  name,
  value,
}: PhoneProps) => {
  const handleOnChange = (val: string) => {
    onChange(name, val || null);
  };

  return (
    <>
      {label && (
        <Typography
          variant="copy1"
          display="block"
          mb="1rem"
          color={hasError ? 'punch' : undefined}
        >
          {label}
        </Typography>
      )}
      <StyledPhone
        value={value || ''}
        onChange={handleOnChange}
        hasError={hasError}
      />
      {helperText && (
        <Typography
          variant="copy2"
          display="block"
          mt="0.5rem"
          data-testid={`error-${name}`}
          color={hasError ? 'punch' : 'driarGray'}
        >
          {helperText}
        </Typography>
      )}
    </>
  );
};

export default Phone;
